import axios from 'axios';

const authBaseURL = 'https://studentapi.anginatlearning.com/api/auth';

const ChangePasswordApi = {
  updatePassword: async (email, currentPassword, newPassword) => {
    try {
      const token = localStorage.getItem('accessToken');
      const response = await axios.post(`${authBaseURL}/update-password`, {
        email,
        currentPassword,
        newPassword
      }, {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        }
      });
      
      return response.data;
    } catch (error) {
      console.error('Password update error:', error);
      throw error.response?.data || { message: 'Password update failed' };
    }
  }
};

export default ChangePasswordApi;